import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LayoutHeader from './components/LayoutHeader';
import LayoutFooter from './components/LayoutFooter';
import HomePage from './pages/HomePage';
import ConvertidorPage from './pages/ConvertidorPage';
import GuiaVucemPage from './pages/GuiaVucemPage';
import MveGuidePage from './pages/MveGuidePage';
import EdocumentMvePage from './pages/EdocumentMvePage';
import PrepararseMvePage from './pages/PrepararseMvePage';
import { usePageMeta } from './seo';

// createRoot replaces the prerendered markup after the browser has already
// jumped to the URL's #anchor, so jump again once the live page is rendered.
const useScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (target) target.scrollIntoView();
  }, [pathname, hash]);
};

// Router-agnostic shell, so scripts/prerender.js can render it inside a
// StaticRouter at build time.
export function AppShell() {
  usePageMeta();
  useScrollToHash();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-800 dark:text-gray-200">
      <LayoutHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/convertidor" element={<ConvertidorPage />} />
        <Route path="/como-convertir-pdf-vucem" element={<GuiaVucemPage />} />
        <Route path="/que-es-manifestacion-de-valor-electronica" element={<MveGuidePage />} />
        <Route path="/como-digitalizar-edocument-manifestacion-de-valor" element={<EdocumentMvePage />} />
        <Route path="/como-prepararse-para-la-mve" element={<PrepararseMvePage />} />
      </Routes>
      <LayoutFooter />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
